import Vue from 'vue'
import VueLazyload from "vue-lazyload";

Vue.use(VueLazyload, {
  error: 'img/happily-logo-white.png',
  // loading: 'img/happily-logo-white.png'
});
